import { render, staticRenderFns } from "./BarStats.vue?vue&type=template&id=6b144fb2&"
import script from "./BarStats.vue?vue&type=script&lang=js&"
export * from "./BarStats.vue?vue&type=script&lang=js&"
import style0 from "./BarStats.vue?vue&type=style&index=0&id=6b144fb2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports